// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__r1+ms","photo":"Header_photo__0O8N8","title":"Header_title__x3ga3","createdBy":"Header_createdBy__gR0h7"};